<template>
  <v-main :style="cardStyle">
    <v-card :elevation="0" >
      <v-alert
          type="success"
          flat
      >
        <v-row>
          <v-col class="grow">
            Наименьшая стоимость электрической энергии возможна при расчетах по {{ best }} ЦК
          </v-col>
          <v-card light style="padding-left: 14px; margin-left: 12px;">
            Поделиться:
            <ShareNetwork
                style="margin-right: 6px;"
                network="telegram"
                :url="link"
                title="Результат расчета на тарифном калькуляторе Etarif"
                :description="description"
            >
              <v-btn icon fab >
                <img style="width:32px; height: 32px; cursor: pointer;" src="../assets/tg2.png">
              </v-btn>
            </ShareNetwork>
            <ShareNetwork
                style="margin-right: 6px;"
                network="email"
                :url="link"
                title="Результат расчета на тарифном калькуляторе Etarif"
                :description="description"
            >
              <v-btn icon fab >
                <img style="width:32px; height: 32px; cursor: pointer;" src="../assets/mail.png">
              </v-btn>            </ShareNetwork>
            <ShareNetwork
                style="margin-right: 6px;"
                network="whatsapp"
                :url="link"
                title="Результат расчета на тарифном калькуляторе Etarif"
                :description="description"
            >
              <v-btn icon fab >
                <img style="width:32px; height: 32px; cursor: pointer;" src="../assets/wa.png">
              </v-btn>            </ShareNetwork>

          </v-card>
          <v-col class="shrink">
            <v-btn small light @click="makexlsx()">Экспорт XLSX</v-btn>
          </v-col>
          <v-col class="shrink">
            <v-btn small light style="margin-right: 12px;" to="/" v-if="result"  >Назад к объему</v-btn>
          </v-col>
        </v-row>
      </v-alert>
      <v-simple-table id="table">
        <template v-slot:default>
          <thead>

          <tr>
            <th class="text-center" >
              <span style="display: none;">
              {{description}}
              </span>
            </th>
            <th class="text-center ">
              Ед изм
            </th>
            <th class="text-center" v-if="!result.fsk">
              1 ЦК
            </th>
            <th class="text-center" v-if="!result.fsk">
              3 ЦК
            </th>
            <th class="text-center">
              4 ЦК
            </th>
          </tr>
          </thead>
          <tbody>
          <tr class="font-weight-bold">
            <td class="text-left">
              Объем э/э
            </td>
            <td class="text-right">
              кВтч
            </td>

            <td class="text-right" v-if="!result.fsk">
              {{ toRound(sum) }}            </td>
            <td class="text-right" v-if="!result.fsk">
              {{ toRound(sum) }}            </td>
            <td class="text-right">
              {{ toRound(sum) }}            </td>
          </tr>

          <tr class="font-weight-bold">
            <td class="text-left">
              Объем мощности
            </td>
            <td class="text-right">
              МВт
            </td>

            <td class="text-right" v-if="!result.fsk">
              {{ toRoundPower(result.power_volume.ck3) }}            </td>
            <td class="text-right" v-if="!result.fsk">
              {{ toRoundPower(result.power_volume.ck3) }}            </td>
            <td class="text-right">
              {{toRoundPower(result.power_volume.ck3)}}            </td>
          </tr>

          <tr class="font-weight-bold">
            <td class="text-left">
              Объем мощности услуги по передаче
            </td>
            <td class="text-right">
              МВт
            </td>

            <td class="text-right" v-if="!result.fsk">
              {{ toRoundPower(result.tr_power.ck1) }}            </td>
            <td class="text-right" v-if="!result.fsk">
              {{ toRoundPower(result.tr_power.ck3) }}            </td>
            <td class="text-right">
              {{toRoundPower(result.tr_power.ck4)}}            </td>
          </tr>


          <tr class="font-weight-bold">
            <td class="text-left">
              Стоимость э/э по договору купли-продажи
            </td>
            <td class="text-right">
              рублей
            </td>

            <td class="text-right" v-if="!result.fsk">
              {{ toRound(dkp.ck1)}}
            </td>
            <td class="text-right" v-if="!result.fsk">
              {{ toRound(dkp.ck3) }}
            </td>
            <td class="text-right">
              {{ toRound(dkp.ck4) }}
            </td>
          </tr>
          <tr class="font-weight-bold">

            <td class="text-left ">
              Стоимость ээ по договору энергоснабжения, в том числе:
            </td>

            <td class="text-right">
              рублей
            </td>

            <td class="text-right" v-if="!result.fsk">
              {{ toRound(result.total_value.ck1) }}
            </td>
            <td class="text-right" v-if="!result.fsk">
              {{ toRound(result.total_value.ck3) }}
            </td>
            <td class="text-right">
              {{ toRound(result.total_value.ck4) }}
            </td>
          </tr>

          <tr class="">

            <td class="text-left ">
              &nbsp;&nbsp;&nbsp;
              Стоимость э/э с учетом мощности, в том числе:
            </td>

            <td class="text-right">
              рублей
            </td>

            <td class="text-right" v-if="!result.fsk">
              {{ toRound(result.electric.ck1) }}
            </td>
            <td class="text-right" v-if="!result.fsk">
              {{ toRound(result.electric.ck3 + result.power.ck3) }}
            </td>
            <td class="text-right">
              {{ toRound(result.electric.ck4 +  result.power.ck4) }}
            </td>
          </tr>

          <tr>
            <td class="text-left">
              &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;
              Стоимость электрической энергии
            </td>

            <td class="text-right"> рублей
            </td>

            <td class="text-right" v-if="!result.fsk">
              {{ toRound(result.electric.ck1) }}
            </td>
            <td class="text-right" v-if="!result.fsk">
              {{ toRound(result.electric.ck3) }}
            </td>
            <td class="text-right">
              {{ toRound(result.electric.ck4) }}
            </td>
          </tr>
          <tr>
            <td class="text-left">
              &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
              Стоимость электрической мощности
            </td>

            <td class="text-right">
              рублей
            </td>
            <td class="text-right" v-if="!result.fsk">
              {{ toRound(result.power.ck1) }}
            </td>
            <td class="text-right" v-if="!result.fsk">
              {{ toRound(result.power.ck3) }}
            </td>
            <td class="text-right">
              {{ toRound(result.power.ck4) }}
            </td>
          </tr>
          <tr>
            <td class="text-left">
              &nbsp;&nbsp;&nbsp; Стоимость услуг по передаче э/э, в  том числе:
            </td>

            <td class="text-right">
              рублей
            </td>

            <td class="text-right" v-if="!result.fsk">
              {{ toRound(result.transfer_service1.ck1) }}
            </td>
            <td class="text-right" v-if="!result.fsk">
              {{ toRound(result.transfer_service1.ck3) }}
            </td>
            <td class="text-right">
              {{ toRound(result.transfer_service1.ck4 + result.transfer_service2.ck4)}}
            </td>
          </tr>
          <tr>
            <td class="text-left">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Стоимость услуг по передаче э/э ставка за компенсацию потерь
            </td>

            <td class="text-right">
              рублей
            </td>

            <td class="text-right" v-if="!result.fsk">
              {{ toRound(result.transfer_service1.ck1) }}
            </td>
            <td class="text-right" v-if="!result.fsk">
              {{ toRound(result.transfer_service1.ck3) }}
            </td>
            <td class="text-right">
              {{ toRound(result.transfer_service1.ck4 ) }}
            </td>
          </tr>
          <tr>
            <td class="text-left">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Стоимость услуг по передаче э/э ставка за содержание сетей
            </td>

            <td class="text-right">
              рублей
            </td>

           <td class="text-right" v-if="!result.fsk"> {{ toRound(result.transfer_service2.ck1) }}
           </td>
            <td class="text-right" v-if="!result.fsk">
              {{ toRound(result.transfer_service2.ck3) }}
            </td>
            <td class="text-right">              {{ toRound(result.transfer_service2.ck4) }}
            </td>
          </tr>
          <tr>
            <td class="text-left">
              &nbsp;&nbsp;&nbsp; Стоимость услуг гарантирующего поставщика - сбытовой надбавки
            </td>

            <td class="text-right">
              рублей
            </td>
            <td class="text-right" v-if="!result.fsk">
              {{ toRound(result.sn_gp.ck1) }}
            </td>
            <td class="text-right" v-if="!result.fsk">
              {{ toRound(result.sn_gp.ck3) }}
            </td>
            <td class="text-right">
              {{ toRound(result.sn_gp.ck4) }}
            </td>
          </tr>

          <tr>
            <td class="text-left">
              &nbsp;&nbsp;&nbsp;  Стоимость услуг инфраструктурных организаций рынка э/э
            </td>

            <td class="text-right">
              рублей
            </td>

            <td class="text-right" v-if="!result.fsk">
              {{ toRound(result.org_cost.ck1) }}
            </td>
            <td class="text-right" v-if="!result.fsk">
              {{ toRound(result.org_cost.ck3) }}
            </td>
            <td class="text-right">
              {{ toRound(result.org_cost.ck4) }}
            </td>
          </tr>

          <tr>
            <td class="text-left">
              Цена э/э за кВтч
            </td>

            <td class="text-right">
              руб/кВтч
            </td>

            <td class="text-right" v-if="!result.fsk">
              {{ toRoundPower(result.price.ck1) }}
            </td>
            <td class="text-right" v-if="!result.fsk">
              {{ toRoundPower(result.price.ck3) }}
            </td>
            <td class="text-right">
              {{ toRoundPower(result.price.ck4) }}
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>

    <!--  <v-alert
          type="info"
      >
        Стоимость по ДКП 1ЦК - {{toRound(dkp.ck1)}}, 3ЦК - {{toRound(dkp.ck3)}}, 4ЦК - {{toRound(dkp.ck4)}},
      </v-alert>-->
    </v-card>
  </v-main>
</template>
<script>
import * as XLSX from 'xlsx'



export default {
  name: 'ResultTable',
  props: ['result', 'sum','dkp','title','description','link','isMobile'],
  data: () => ({
    dialog: false,
  }),
  methods: {
    makexlsx(){
      var dom_element=document.getElementById('table');
      var workbook = XLSX.utils.table_to_book(dom_element,{raw:true});
      XLSX.writeFile(workbook, "EtarifResult.xlsx", { compression: true });
    },
    toRoundPower(val) {
      var result = Math.round(val * 100000) / 100000;
      return result;
    },
    toRound(val) {
      var result =Math.round(val * 100) / 100;
      if (!result){
        result =Math.round(val * 10000) / 10000;
      }
      return result.toLocaleString('ru');
    },
  },
  computed: {
    cardStyle(){
      if (this.isMobile){
        return ' ';
      }
      return 'padding: 0 0;';
    },
    best() {
      if (this.result.total_value.ck1<this.result.total_value.ck3 && this.result.total_value.ck1<this.result.total_value.ck4){
        return 1;
      }
      if (this.result.total_value.ck3<this.result.total_value.ck1 && this.result.total_value.ck3<this.result.total_value.ck4){
        return 3;
      }
      return 4;
    },
  }
}
</script>
<style>
.v-main {
  overflow: scroll;
  height: 100vh;
}
</style>
<style scoped>
td {
  border: #B2BABB 1px solid;
}
th {
  border: #B2BABB 1px solid;
}
</style>

